<template>
  <div class="od-card">
    <div class="od-card-header">
      <div class="od-card-header-left">
        <a-icon type="car" class="od-card-header-icon" />
        <p class="od-card-header-title">
          Detail Pengiriman
        </p>
      </div>
    </div>
    <div class="od-card-body">
      <div class="od-info-grid">
        <span class="od-info-label">Kurir</span>
        <span class="od-info-value">
          {{ order.shipment_data && order.shipment_data.courier }}
          —
          {{ (order.shipment_data && (order.shipment_data.service_name || order.shipment_data.service_code)) || '' }}
        </span>

        <span class="od-info-label">Alamat Pengiriman</span>
        <div>
          <span class="od-info-value" style="display:block;">
            {{ order.destination_data && order.destination_data.name }}
          </span>
          <span style="color:#6b7280;font-size:13px;display:block;">
            {{ order.destination_data && order.destination_data.phone }}
          </span>
          <p style="color:#4b5563;margin-top:4px;font-size:13px;">
            {{ order.destination_data && order.destination_data.address }}<template v-if="order.destination_data && order.destination_data.sub_district">
              , {{ order.destination_data.sub_district }}
            </template><template v-if="order.destination_data && order.destination_data.district">
              , {{ order.destination_data.district }}
            </template><template v-if="order.destination_data && order.destination_data.city">
              , {{ order.destination_data.city }}
            </template><template v-if="order.destination_data && order.destination_data.province">
              , {{ order.destination_data.province }}
            </template> {{ order.destination_data && order.destination_data.postal_code }}
          </p>
        </div>

        <template v-if="order.shipment_data && order.shipment_data.awb">
          <span class="od-info-label">No. Resi</span>
          <div class="od-flex od-flex-center od-gap-2">
            <span class="od-mono">{{ order.shipment_data.awb }}</span>
            <button class="od-copy-btn" @click="copyToClipboard(String(order.shipment_data.awb), 'No. Resi')">
              <a-icon type="copy" /> Salin
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDeliveryInfo',
  props: {
    order: { type: Object, default: null },
    copyToClipboard: { type: Function, required: true },
  },
}
</script>
